import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
    GET_LOGIN_LOGS: {
        url: "logboek-login",
        method: "get",
    },

    GET_ROLES: {
        url: 'getRoles',
        method: 'get'
    },

    GET_AUTHORIZATION_LOGS: {
        url: "authorization-logs",
        method: "get",
    },

    GET_PLATFORMS: {
        url: 'platforms',
        method: 'get'
    }
};

export const useLoginLogs = (role, platform) => {
    const params = new URLSearchParams();

    if (role) {
        params.append("role", role);
    }

    if (platform) {
        params.append("platform", platform);
    }

    return useApiFetcherSWR({
        ...API_ENDPOINT.GET_LOGIN_LOGS,
        url: params.toString()
            ? `${API_ENDPOINT.GET_LOGIN_LOGS.url}?${params.toString()}`
            : API_ENDPOINT.GET_LOGIN_LOGS.url,
    });
};

export const useRoles = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_ROLES);

export const usePlatforms = () =>
    useApiFetcherSWR(API_ENDPOINT.GET_PLATFORMS);


export const useAuthorizationLogs = (communityName = "Alle") =>
    useApiFetcherSWR({
        ...API_ENDPOINT.GET_AUTHORIZATION_LOGS,
        url:
            communityName && communityName !== "Alle besturen"
                ? `authorization-logs?search=${communityName}`
                : API_ENDPOINT.GET_AUTHORIZATION_LOGS.url,
    });